import { jsx, Fragment } from 'react/jsx-runtime';
import { ConfirmPopup } from 'primereact/confirmpopup';

function SimplePopup(_ref) {
  let {
    config,
    visible,
    onHide
  } = _ref;
  var _a, _b;
  return jsx(ConfirmPopup, {
    visible: visible,
    target: config === null || config === void 0 ? void 0 : config.target,
    className: config === null || config === void 0 ? void 0 : config.className,
    message: (_a = config === null || config === void 0 ? void 0 : config.content) !== null && _a !== void 0 ? _a : jsx(Fragment, {}),
    footer: (_b = config === null || config === void 0 ? void 0 : config.footer) !== null && _b !== void 0 ? _b : jsx(Fragment, {}),
    onHide: onHide
  });
}

export { SimplePopup };
